import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link, navigate } from '@reach/router';
import NavContainer from './NavContainer';
import NavLogo from './NavLogo';
import { useDispatch } from 'react-redux';
import { logoutUser } from 'state/user/UserActions';
import NavLink from './NavLink';
import NavDropdown from './NavDropdown';
import { AdminViewModeContext } from 'state/AdminViewModeContext';

const AdminNav: React.FC = (): JSX.Element => {
   const dispatch = useDispatch();
   const { setViewingMode } = useContext(AdminViewModeContext);

   return (
      <Container>
         <NavLogo />
         <Links>
            <li>
               <NavLink to="/waveforms">Waveforms</NavLink>
            </li>
            <li>
               <NavLink to="/sensations">Sensations</NavLink>
            </li>
            <li>
               <NavLink to="/customers">Customers</NavLink>
            </li>
            <li>
               <NavLink to="/admins">Admins</NavLink>
            </li>
         </Links>
         <NavDropdown />
         <ButtonContainer>
            <Links>
               <li>
                  <Account to="/profile">Account</Account>
               </li>
               <li>
                  <ViewAsCustomer
                     onClick={() => {
                        setViewingMode('customer');
                        navigate('/profile');
                     }}>
                     View as customer
                  </ViewAsCustomer>
               </li>
               <li>
                  <Logout
                     to="/"
                     onClick={() => {
                        dispatch(logoutUser());
                        setViewingMode('admin');
                     }}>
                     Logout
                  </Logout>
               </li>
            </Links>
         </ButtonContainer>
      </Container>
   );
};

export default AdminNav;

const Container = styled(NavContainer)`
   justify-content: flex-start;
`;

const Links = styled.ul`
   display: block;
   padding-top: 3px;
   li {
      list-style-type: none;
      display: inline;
      &:not(:first-child):before {
         content: ' | ';
         color: ${({ theme }) => theme.primaryBlueLight};
         font-size: 1.1em;
      }
   }
   @media only screen and (max-width: 768px) {
      display: none;
   }
`;
const ButtonContainer = styled.div`
   margin-left: auto;
   padding-top: 3px;
`;
const Logout = styled(Link).attrs({ role: 'button' })``;
const Account = styled(Link)``;

const ViewAsCustomer = styled.span`
   cursor: pointer;
`;
